define('modules/form_editor/views/editor_custom_fblogin',['require','exports','module','base/view','ldsh!../templates/editor_custom_fblogin'],function(require,exports,module){
  "use strict";
  var BaseView = require("base/view");

  var FBLoginButtonEditorView = BaseView.extend({
    template: require("ldsh!../templates/editor_custom_fblogin"),
    events: {
      "change .js-fb-app-id": "updateModel",
      "change .js-fb-button-size": "updateSize",
      "change .js-fb-button-position": "updatePosition"
    },
    updateModel: function(e){
      e.preventDefault();
      this.model.set("appId", this.$(".js-fb-app-id").val());
    },
    updateSize: function(e){
      e.preventDefault();
      var size = this.$(".js-fb-button-size option:selected").val();
      this.model.set("size", size);
    },
    updatePosition: function(e){
      e.preventDefault();
      var position = this.$(".js-fb-button-position option:selected").val();
      this.model.set("position", position);
    },
    onRender: function(){
      var size = this.model.get("size"),
          position = this.model.get("position");
      this.$(".js-fb-button-size option[value='" + size + "']").attr("selected", true);
      this.$(".js-fb-button-position option[value='" + position + "']").attr("selected", true);
      this.$el.i18n();
    },
  });
  module.exports = FBLoginButtonEditorView;
});

